var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvedaPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 14 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#120E02",
    d: "M3.6,14H2l4.8-9l4.6,9H9.9L6.8,7.8L3.6,14z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#120E02",
    d: "M6.8,12.9c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C7.8,12.5,7.3,12.9,6.8,12.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#120E02",
    d: "M11.3,6.8V8h-0.7V6.8H9.4V6.2h1.2V5h0.7v1.2h1.2v0.7H11.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#120E02",
    d: "M11,0.8H3c-1.2,0-2.2,1-2.2,2.2v13c0,1.2,1,2.2,2.2,2.2h8 c1.2,0,2.2-1,2.2-2.2V3C13.2,1.8,12.2,0.8,11,0.8z M3,0C1.3,0,0,1.3,0,3v13c0,1.7,1.3,3,3,3h8c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvedaPlus);
export default __webpack_public_path__ + "static/media/aveda-plus.3de4be01.svg";
export { ForwardRef as ReactComponent };